/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IUsercentricsBodyViewProps } from './usercentrics-body';
import { msdyn365Commerce } from '@msdyn365-commerce/core-internal'; //

export default (props: IUsercentricsBodyViewProps) => {
    if (msdyn365Commerce.isBrowser) {
        const { context } = props;
        window.addEventListener('click', function(event) {
            const el = event.target as HTMLAnchorElement;
            if (el.id === 'uc-privacy-link') {
                event.preventDefault();
                //@ts-ignore
                window.UC_UI.showSecondLayer();
            }
        });

        window.addEventListener('UC_UI_CMP_EVENT', function(event) {
            //@ts-ignore
            context.request.cookies.setConsentCookie();
            //@ts-ignore
        });
    }

    return null;
};
